import { CURRENT_LOCATION_INITIAL_OPTIONS } from '../../constants/Constants'
import LocationSearchActions from '../../actions/LocationSearchActions'
import { useEffect, useState } from 'react'

export function useCurrentLocation (currentLocation = {}) {
  const [useCurrentLocation, setUseCurrentLocation] = useState(false)
  useEffect(() => {
    navigator.permissions &&
    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      if (permissionStatus.state === 'granted') {
        setUseCurrentLocation(true)
      }
    })
  })

  if (useCurrentLocation) {
    return {
      ...currentLocation,
      ...CURRENT_LOCATION_INITIAL_OPTIONS,
      handleCurrentLocationPromise: LocationSearchActions.getCurrentLocation.bind(LocationSearchActions)
    }
  }
  return currentLocation
}
